import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { apiGetNotifications } from "../../../api/notifications";
import { Bell, ArrowLeft } from "lucide-react";
import "./Notifications.scss";

const Notifications = () => {
  const history = useHistory();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const formatRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 60) {
      return `${diffInMinutes} minuto${diffInMinutes !== 1 ? 's' : ''} atrás`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hora${diffInHours !== 1 ? 's' : ''} atrás`;
    } else {
      return `${diffInDays} dia${diffInDays !== 1 ? 's' : ''} atrás`;
    }
  };

  const loadNotifications = (pageNumber = 1) => {
    setLoading(true);
    apiGetNotifications({ page: pageNumber, page_size: 20 })
      .then(data => {
        if (data && data.items) {
          if (pageNumber === 1) {
            setNotifications(data.items);
          } else {
            setNotifications(prev => [...prev, ...data.items]);
          }
          setTotalPages(Math.ceil(data.total / data.page_size));
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const handleLoadMore = () => {
    if (page < totalPages && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      loadNotifications(nextPage);
    }
  };

  const markAsRead = (notificationId) => {
    // Implementar API call para marcar como lida
    setNotifications(prev =>
      prev.map(notification =>
        notification.id === notificationId
          ? { ...notification, read: true }
          : notification
      )
    );
  };

  return (
    <div className="notifications-page">
      <div className="notifications-header-page">
        <button
          onClick={() => history.goBack()}
          className="back-button"
        >
          <ArrowLeft className="back-icon" />
        </button>
        <div className="header-content">
          <Bell className="page-icon" />
          <h1>Notificações</h1>
        </div>
      </div>

      <div className="notifications-container-page">
        {loading && notifications.length === 0 ? (
          <div className="loading-state">
            <p>Carregando notificações...</p>
          </div>
        ) : notifications.length === 0 ? (
          <div className="empty-state">
            <Bell className="empty-icon" />
            <h2>Nenhuma notificação</h2>
            <p>Você não possui notificações no momento.</p>
          </div>
        ) : (
          <>
            <div className="notifications-list-page">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-card ${!notification.read ? 'unread' : ''}`}
                  onClick={() => markAsRead(notification.id)}
                >
                  <div className="notification-header-card">
                    <h3 className="notification-title">{notification.title}</h3>
                    {!notification.read && (
                      <div className="unread-indicator-page"></div>
                    )}
                  </div>
                  {notification.description && (
                    <p className="notification-description">{notification.description}</p>
                  )}
                  <div className="notification-footer-card">
                    <span className="notification-time-page">
                      {formatRelativeTime(notification.created_at)}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {page < totalPages && (
              <div className="load-more-container">
                <button
                  onClick={handleLoadMore}
                  disabled={loading}
                  className="load-more-button"
                >
                  {loading ? 'Carregando...' : 'Carregar mais'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Notifications;